import { render, staticRenderFns } from "./RegisterOrUploadTemplate.vue?vue&type=template&id=593f05fa&scoped=true&"
import script from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js&"
export * from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOrUploadTemplate.vue?vue&type=style&index=0&id=593f05fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f05fa",
  null
  
)

export default component.exports